import React from 'react';
import SideToolbar from './side-toolbar';
import Editor from './Editor';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import StepSidebar from '../../../../organisms/step-sidebar/StepSidebar';
import { setActiveLayer } from '../../../../../redux/toolsSlice';
import { getMainConfig, removeLayerConfig } from '../../../../../redux/stepsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getMaterial } from '../../../../../redux/materialSlice';
import { getValue } from '../../../utils/tools';
import PathEditorShell from './v2/PathEditorShell';

// Flip to false to instantly revert to the legacy editor (kept intact below).
const USE_V2 = true;

const Authoring = ({ previewDevice }) => {
  const dispatch = useDispatch();
  const material = useSelector((state) => getMaterial(state));
  const mainConfig = useSelector((state) => getMainConfig(state));
  const config = Array.isArray(mainConfig) && mainConfig.length > 0 ? mainConfig : material?.config;
  const defaultColors = {
    background: '#F6F8F9',
    config
  };
  const baBGColor = getValue(defaultColors, 'ba', 'baHeaderColor');
  const previewSurfaceStyle = {
    '--path-bottom-bg': baBGColor || '#F6F8F9',
    '--path-bottom-bg-end': baBGColor || '#F6F8F9'
  };

  const removeFocusElement = (e) => {
    if (e.target?.role === 'element-area') {
      dispatch(setActiveLayer({}));
      dispatch(removeLayerConfig());
    }
  };

  return (
    <div
      className={`main-content-path-authoring un-path-authoring-shell${USE_V2 ? ' un-pe-root' : ''}`}
      style={{ height: 'calc(100vh - 6px - 67px)', maxHeight: 'calc(100vh - 6px - 67px)' }}
    >
      <DndProvider backend={HTML5Backend}>
        {USE_V2 ? (
          <div role="element-area" className="un-pe-canvas-host" style={previewSurfaceStyle} onClick={removeFocusElement}>
            <PathEditorShell previewDevice={previewDevice} />
          </div>
        ) : (
          <>
            <div role="element-area" className="contant-path-authoring scroll-block un-path-authoring-canvas" style={previewSurfaceStyle} onClick={removeFocusElement}>
              <Editor previewDevice={previewDevice} />
            </div>
            <aside className="un-path-authoring-rail">
              <StepSidebar />
              <SideToolbar />
            </aside>
          </>
        )}
      </DndProvider>
    </div>
  );
};

export default Authoring;
